import * as React from 'react';
import { useStyles } from '@sravni/react-utils';
import { COLORS } from '../../../constants/colors.js';
import { CONTENT_SIZES } from '../../../constants/sizes.js';
import { VARIANTS } from '../../../constants/variants.js';
import modules_e5067360 from '../styles/Icon.module.less.js';

/**
 * @description Icon container.
 *
 * @component
 * @example
 * ```jsx
 * <Icon size={28} icon={<ArrowUpIcon />} />
 * ```
 */
const Icon = React.forwardRef((props, ref) => {
    const { icon, size, strong, color, background, variant = VARIANTS.SECONDARY, shape, style = {}, children, className, ...restProps } = props;
    const cx = useStyles(modules_e5067360);
    const classNames = cx(className, 'container', {
        strong,
        [`size-${size}`]: size,
        [`color-${color}`]: color,
        [`background-${variant}-${background}`]: background,
        [`shape-${shape}`]: shape,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'as-container': shape,
    });
    return (React.createElement("span", { "data-qa": "Icon", ref: ref, className: classNames, style: style, ...restProps }, children || icon));
});
Icon.defaultProps = {
    size: CONTENT_SIZES.S20,
    variant: VARIANTS.SECONDARY,
    background: COLORS.DARK,
};
Icon.displayName = 'Icon';

export { Icon };
//# sourceMappingURL=Icon.js.map
